export default "__VITE_ASSET__BI668YOl__"